'use strict';

angular.module('ntmApp').factory('TodaysAssignments', ['$rootScope', '$routeParams', '$sce', 'FlashService', 'Utils', 'TodaysAssignmentsService', 'DBConstants', 'ConfirmationService',
  '$q', '$location', 'TALocationService', '$timeout', 'Constants', 'UserInfo', 'RoomRackCensus', 'ActivityHighlighting', 'SignalR', 'ElementIdHelper',
  function ($rootScope, $routeParams, $sce, FlashService, Utils, TodaysAssignmentsService, DBConstants, ConfirmationService,
    $q, $location, TALocationService, $timeout, Constants, UserInfo, RoomRackCensus, ActivityHighlighting, SignalR, ElementIdHelper) {

    function TodaysAssignments(scope, level) {

      var self = this;
      var activityCopy = {};
      var currentUser = null;
      var facilityCode = $routeParams.facilityId;
      var roomNumber = $routeParams.roomId;
      var scheduleId = $routeParams.scheduleId;
      var socketData = null;

      self.roomRackCensus = new RoomRackCensus(self);
      self.ActivityHighlighting = new ActivityHighlighting(self);

      UserInfo.GetUserInfo().then(function (user) {
        currentUser = user;
      });

      self.dataLoaded = false;
      self.showOnlyMyActivities = false;

      self.activityType = Constants.ActivityTypes;
      self.QuantityTypes = Constants.QuantityTypes;
      self.DBActions = Constants.DBActions;
      self.progressStatuses = DBConstants.ProgressStatuses;

      SignalR.StartConnection(function (callBack) {
        if (needRefresh(callBack)) {

          if (level === Constants.TodaysAssignments.Levels.HomePage) {
            self.LoadAssignmentsData(true);
          }

          if (level === Constants.TodaysAssignments.Levels.RoomGroups) {
            self.LoadRoomData(true);
          }

          if (level === Constants.TodaysAssignments.Levels.ActivityDetails) {
            self.LoadActivityData(true);
          }

          if (level === Constants.TodaysAssignments.Levels.PreparationList) {
            self.LoadPreparationListData(true);
          }

          socketData = callBack;
        }
      }, '/DailyStatistic');


      self.closeSignalRConnection = function () {
        SignalR.Stop();
      };

      $rootScope.getScheduleData = function (date) {
        self.LoadAssignmentsData(date);
      };

      self.isCurrentDaySelected = function () {
        return moment().isSame(moment($rootScope.scheduleDate), 'days');
      };

      self.isHomePageLevel = function () {
        return level === Constants.TodaysAssignments.Levels.HomePage;
      };

      self.isRoomGroupsLevel = function () {
        return level === Constants.TodaysAssignments.Levels.RoomGroups;
      };

      self.isActivityDetailsLevel = function () {
        return level === Constants.TodaysAssignments.Levels.ActivityDetails;
      };

      self.isPreparationListLevel = function () {
        return level === Constants.TodaysAssignments.Levels.PreparationList;
      };

      self.LoadAssignmentsData = function (isDataChangedBySocket, scheduleDate) {

        self.dataLoaded = isDataChangedBySocket;
        FlashService.ShowProgressBar();

        TodaysAssignmentsService.GetAssignments(moment(scheduleDate ? scheduleDate : $rootScope.scheduleDate)).then(function (result) {

          if ((!result.data.roomActivities || result.data.roomActivities.length === 0) && (!result.data.otherActivities || result.data.otherActivities.length === 0) && (!result.data.qcCheckActivitiesByRooms || result.data.qcCheckActivitiesByRooms.length === 0)) {
            Utils.OpenModal('You do not have any assignments for today.', 'ng1/src/common/alertPopup.html');
          } else {
            self.roomActivities = result.data.roomActivities;
            self.qcCheckActivitiesByRooms = result.data.qcCheckActivitiesByRooms;
            self.otherActivities = composeActivitiesGroup(result.data.otherActivities);
            self.actualHoursSystemPreference = result.data.actualHoursSystemPreference;
            self.totalHoursRemaining = result.data.totalHoursRemaining;
            self.preparationItemsCount = result.data.preparationItemsCount;
            self.dataLoaded = true;
            FlashService.HideProgressBar();

            if (sessionStorage.scheduleIdToHighlight) {
              self.ActivityHighlighting.TryToHighlightOtherActivity(sessionStorage.scheduleIdToHighlight);
              sessionStorage.scheduleIdToHighlight = '';
            }

            if (sessionStorage.selectedActivity) {
              self.scrollToActivity(parseInt(sessionStorage.selectedActivity));
              sessionStorage.selectedActivity = '';
            }

            if (isDataChangedBySocket) {
              FlashService.Success("Your schedule has been updated");

              var records = self.roomActivities.filter(function (activity) {
                return activity.scheduleIds.some(function (scheduleId) { return socketData.scheduleIds.indexOf(scheduleId) > -1; });
              });

              records = self.qcCheckActivitiesByRooms.filter(function (activity) {
                return activity.scheduleIds.some(function (scheduleId) { return socketData.scheduleIds.indexOf(scheduleId) > -1; });
              });

              records = records.concat(self.otherActivities.filter(function (activity) { return socketData.scheduleIds.indexOf(activity.scheduleId) > -1; }));

              if (records.length > 0) {

                records.forEach(x => x.highlighted = true);

                $timeout(function () {
                  records.forEach(x => x.highlighted = false);
                }, 30000);
              }
            }
          }
        });

        loadTimeSpecificActivities(isDataChangedBySocket);
        self.LoadPreparationListData();
      };

      self.LoadPreparationListData = function (isDataChangedBySocket) {

        var deferred = $q.defer();
        FlashService.ShowProgressBar();

        var data = {
          date: moment()
        };

        TodaysAssignmentsService.GetPreparationItems(data).then(function (result) {
          self.preparationActivitiesForToday = result.data.preparationItemsForToday;
          self.preparationActivitiesForTomorrow = result.data.preparationItemsForTomorrow;
          self.roomNotes = result.data.roomNotes;

          self.roomNotes.forEach(function (roomNoteItem) {
            roomNoteItem.date = (moment(roomNoteItem.date)).format('LL');
            roomNoteItem.isEditMode = false;
            roomNoteItem.initialNoteValue = roomNoteItem.note;
          });

          self.roomNotesForTomorrow = self.roomNotes.filter(function (roomNoteItem) {
            return ((moment(roomNoteItem.date)).startOf('day')).isSame((moment().add(1, 'days')).startOf('day'));
          });

          self.spreadedGroupsForToday = spreadPreparationActivitiesIntoGroups(self.preparationActivitiesForToday);
          self.spreadedGroupsForTomorrow = spreadPreparationActivitiesIntoGroups(self.preparationActivitiesForTomorrow);

          self.roomNotesDropdown = getItemsForRoomNotesDropdown(self.spreadedGroupsForTomorrow.facilityRoomActivitiesGroups, self.roomNotes);
          spreadRoomNotesIntoPrepList(self.spreadedGroupsForToday.facilityRoomActivitiesGroups, self.roomNotes);
          spreadRoomNotesIntoPrepList(self.spreadedGroupsForTomorrow.facilityRoomActivitiesGroups, self.roomNotes);

          self.spreadedGroupsForToday.label = 'Today';
          self.spreadedGroupsForTomorrow.label = 'Tomorrow';

          self.selectedSpreadedGroups = self.spreadedGroupsForToday;

          self.spreadedGroupsForTomorrow.tabIsSelected = false;
          self.spreadedGroupsForToday.tabIsSelected = true;

          if (isDataChangedBySocket) {
            FlashService.Success("Your schedule has been updated");
          }

          deferred.resolve();
        });

        return deferred.promise;
      };

      self.LoadRoomData = function (isDataChangedBySocket) {

        self.dataLoaded = isDataChangedBySocket;
        FlashService.ShowProgressBar();

        var data = {
          date: moment(),
          facilityCode: facilityCode,
          roomNumber: roomNumber
        };

        TodaysAssignmentsService.GetRoomDetails(data).then(function (result) {
          self.roomInfo = composeRoomData(result.data.roomDetail);
          self.roomActivitiesGroups = result.data.roomActivitiesGroups;
          self.actualHoursSystemPreference = self.roomInfo.actualHoursSystemPreference;

          self.roomActivitiesGroups.forEach(function (roomActivitiesGroup) {
            roomActivitiesGroup.activities = composeActivitiesGroup(roomActivitiesGroup.activities);
            createAdHocCountsActivitiesGroup(roomActivitiesGroup);
          });
          self.totalHoursRemaining = self.roomInfo.totalHoursRemaining;
          self.dataLoaded = true;
          FlashService.HideProgressBar();

          $rootScope.todaysAssignmentsTitle = self.roomInfo.facilityName + ': ' + self.roomInfo.roomNumber;

          if (sessionStorage.scheduleIdToHighlight) {
            self.roomActivitiesGroups.forEach(function (roomActivitiesGroup) {
              self.ActivityHighlighting.HighlightActivityInRoomGroup(sessionStorage.scheduleIdToHighlight, roomActivitiesGroup);
            });

            sessionStorage.scheduleIdToHighlight = '';
          }

          if (sessionStorage.selectedActivity) {

            var groupWithActivity = self.roomActivitiesGroups.firstOrDefault(function (group) {
              return group.activities.some(function (activity) {
                return activity.scheduleId === parseInt(sessionStorage.selectedActivity);
              });
            });

            if (groupWithActivity) {
              groupWithActivity.expanded = true;
              self.scrollToActivity(parseInt(sessionStorage.selectedActivity));
            }

            sessionStorage.selectedActivity = '';
          }

          if (isDataChangedBySocket) {
            FlashService.Success("Your schedule has been updated");

            var records = self.roomActivitiesGroups.filter(function (group) {
              return group.activities.filter(function (activity) { return socketData.scheduleIds.indexOf(activity.scheduleId) > -1; }).length > 0;
            });

            if (records.length > 0) {

              records.forEach(x => {
                var activities = x.scheduleIds.filter(function (scheduleId) { return socketData.scheduleIds.indexOf(scheduleId) > -1; });
                activities.forEach(a => a.highlighted = true);
                x.highlighted = true;
              });

              $timeout(function () {
                records.forEach(x => {
                  x.scheduleIds.forEach(a => a.highlighted = false);
                  x.highlighted = false;
                });
              }, 30000);
            }
          }

          self.roomRackCensus.LoadRoomRackCensusButton(isDataChangedBySocket);
        });

        loadTimeSpecificActivities(isDataChangedBySocket);
        self.LoadPreparationListData();
      };

      self.LoadActivityData = function (isDataChangedBySocket) {

        self.dataLoaded = isDataChangedBySocket;
        FlashService.ShowProgressBar();

        var data = {
          date: moment(),
          scheduleId: scheduleId
        };

        sessionStorage.selectedActivity = scheduleId;

        TodaysAssignmentsService.GetActivityDetails(data).then(function (result) {
          self.activityData = result.data.activityInformation;
          self.activityAdditionalInfo = composeActivityData(result.data.additionalInfo);

          activityCopy = angular.copy(self.activityData);
          self.totalHoursRemaining = self.activityAdditionalInfo.totalHoursRemaining;

          self.dataLoaded = true;
          FlashService.HideProgressBar();

          sessionStorage.scheduleIdToHighlight = '';

          if (self.activityData.facilityCode && self.activityData.roomNumber) {
            $rootScope.todaysAssignmentsTitle = self.activityData.facilityCode + ': ' + self.activityData.roomNumber;
          } else {
            $rootScope.todaysAssignmentsTitle = 'Today\'s Assignments';
          }

          if (isDataChangedBySocket) {
            FlashService.Success("Your schedule has been updated");
          }

          loadTimeSpecificActivities(isDataChangedBySocket);
          self.LoadPreparationListData();
        });
      };

      self.GetTotalRemainingHours = function (list, property) {
        return list.sumOf(property);
      };

      self.StartWorking = function () {

        var currentTime = moment();

        var data = {
          facilityCode: facilityCode,
          roomNumber: roomNumber,
          date: currentTime
        };

        var loading = FlashService.Loading();
        TodaysAssignmentsService.StartWorking(data).then(function () {
          loading.dismiss();

          self.roomInfo.roomIsStarted = true;
          self.roomInfo.roomStartedTime = currentTime.format('hh:mm A');
        });
      };

      self.MarkInProgress = function (activity) {

        var request = {
          statusId: self.progressStatuses.getProgressStatusIdByStatusName(self.progressStatuses.StatusNamesConstants.InProgress)
        };

        if (activity.name !== 'Ad Hoc Counts') {
          request.scheduleIds = [activity.scheduleId];
        } else {
          request.scheduleIds = [];
          activity.dataCollectionItems.forEach(function (item) {
            request.scheduleIds.push(item.scheduleId);
          });
        }

        var activityCopy = angular.copy(activity);

        if (activity.progressStatusName === self.progressStatuses.StatusNamesConstants.Completed) {
          self.totalHoursRemaining += activity.remainingDuration;
        }

        updateActivity(activity, self.progressStatuses.StatusNamesConstants.InProgress);

        TodaysAssignmentsService.UpdateActvityStatus(request).then(function (result) {

          if (!result.success) {

            if (activityCopy.progressStatusName === self.progressStatuses.StatusNamesConstants.Completed) {
              self.totalHoursRemaining -= activity.remainingDuration;
            }

            updateActivity(activity, activityCopy.progressStatusName);
          }

          loadTimeSpecificActivities().then(function () {

          });
        });

      };

      self.MarkNotStarted = function (activity) {

        var request = {
          statusId: self.progressStatuses.getProgressStatusIdByStatusName(self.progressStatuses.StatusNamesConstants.NotStarted)
        };

        if (activity.name !== 'Ad Hoc Counts') {
          request.scheduleIds = [activity.scheduleId];
        } else {
          request.scheduleIds = [];
          activity.dataCollectionItems.forEach(function (item) {
            request.scheduleIds.push(item.scheduleId);
          });
        }

        var activityCopy = angular.copy(activity);

        if (activity.progressStatusName === self.progressStatuses.StatusNamesConstants.Completed) {
          self.totalHoursRemaining += activity.remainingDuration;
        }

        updateActivity(activity, self.progressStatuses.StatusNamesConstants.NotStarted);

        TodaysAssignmentsService.UpdateActvityStatus(request).then(function (result) {

          if (!result.success) {

            if (activityCopy.progressStatusName === self.progressStatuses.StatusNamesConstants.Completed) {
              self.totalHoursRemaining -= activity.remainingDuration;
            }

            updateActivity(activity, activityCopy.progressStatusName);
          }

          loadTimeSpecificActivities().then(function () {

          });
        });
      };

      self.ShowInstructions = function (name, instructions) {
        FlashService.Alert(instructions, name + ' instructions', 'dismiss');
      };

      self.CompleteRack = function (rack) {

        var notCompletedActivities = rack.activities.filter(function (activity) {
          return activity.progressStatusName !== self.progressStatuses.StatusNamesConstants.Completed;
        });

        var adHocCountNotCompletedActivities = rack.adHocCountActivities.filter(function (activity) {
          return activity.progressStatusName !== self.progressStatuses.StatusNamesConstants.Completed;
        });

        var hasNoUncompletedDataCollectionItems = notCompletedActivities.every(function (activity) {
          return !activity.dataCollectionItems || activity.dataCollectionItems.length === 0 || !activity.dataCollectionItems.some(function (item) {
            return item.required && item.value !== 0 && !item.value;
          });
        });

        var hasNoUncompletedAdHocCountActivities = adHocCountNotCompletedActivities.every(function (activity) {
          return !activity.dataCollectionItems || activity.dataCollectionItems.length === 0 || !activity.dataCollectionItems.some(function (item) {
            return item.required && item.value !== 0 && !item.value;
          });
        });

        if (hasNoUncompletedDataCollectionItems && hasNoUncompletedAdHocCountActivities) {
          if (adHocCountNotCompletedActivities.length === 0) {
            markActivitiesComplete(notCompletedActivities);
          } else {
            markActivitiesComplete(notCompletedActivities);
            markAdHocCountsComplete(adHocCountNotCompletedActivities);
          }

        } else {
          var activitiesWithDataCollection = notCompletedActivities.filter(function (activity) {
            return activity.dataCollectionItems && activity.dataCollectionItems.some(function (item) {
              return item.required && item.value !== 0 && !item.value;
            });
          });

          var adHocCountActivitiesWithDataCollection = adHocCountNotCompletedActivities.filter(function (activity) {
            return activity.dataCollectionItems && activity.dataCollectionItems.some(function (item) {
              return item.required && item.value !== 0 && !item.value;
            });
          });

          if (activitiesWithDataCollection && activitiesWithDataCollection.length > 0) {
            activitiesWithDataCollection.forEach(function (activity) {
              activity.isHighlighted = true;

              activity.dataCollectionItems.forEach(function (item) {

                if (item.required && item.value !== 0 && !item.value) {
                  item.isNotFilled = true;
                }
              });

            });

            self.scrollToActivity(activitiesWithDataCollection[0].scheduleId);
          }

          if (adHocCountActivitiesWithDataCollection && adHocCountActivitiesWithDataCollection.length > 0) {
            adHocCountActivitiesWithDataCollection.forEach(function (activity) {
              activity.isHighlighted = true;

              activity.dataCollectionItems.forEach(function (item) {

                if (item.required && item.value !== 0 && !item.value) {
                  item.isNotFilled = true;
                }
              });

            });

            if (!activitiesWithDataCollection || activitiesWithDataCollection.length === 0) {
              self.scrollToActivity(adHocCountActivitiesWithDataCollection[0].scheduleId);
            }
          }
        }
      };

      self.MarkComplete = function (activity, isAdHocCountsActivity) {

        if (activity.dataCollectionItems && activity.dataCollectionItems.length > 0) {

          var requiredFieldNotFilled = false;

          activity.dataCollectionItems.forEach(function (item) {

            if (item.name) {

              if (item.required && (item.value == "" || item.value === null || angular.isUndefined(item.value))) {
                requiredFieldNotFilled = true;
                item.isNotFilled = true;
              }
            }
          });

          if (requiredFieldNotFilled) {
            FlashService.Error('Please, fill all required Data Collection fields');
            return;
          }
        }

        if (isAdHocCountsActivity) {
          markAdHocCountsComplete([activity]);
        } else {
          markActivitiesComplete([activity]);
        }
      };

      self.CompleteTimeSpecificActivity = function (activity) {

        var loading = FlashService.Loading();

        var checkIsRoomStartedRequest = {
          date: moment(),
          facilityCode: activity.facilityCode,
          roomNumber: activity.roomNumber
        };

        TodaysAssignmentsService.IsRoomStarted(checkIsRoomStartedRequest).then(function (result) {

          loading.dismiss();

          var completeAction = function (needStartInRoom) {
            markCompleteTimeSpecificActivity(activity, needStartInRoom);
          };

          if (result.data.roomIsStarted) {
            completeAction(false);
          } else {
            ConfirmationService.YesNoConfirmation("You need to start the room before you can complete this activity.", null, { no: 'No, cancel', yes: 'Yes, Start Room' })
              .Yes(function () {
                completeAction(true);
              })
              .Ask();
          }
        });

      };

      self.SaveActivity = function () {

        if (self.activityData.dataCollectionItems && self.activityData.dataCollectionItems.length > 0) {

          var requiredFieldNotFilled = false;

          self.activityData.dataCollectionItems.forEach(function (item) {

            if (item.name) {

              if (item.required && (item.value == "" || item.value === null || angular.isUndefined(item.value))) {
                requiredFieldNotFilled = true;
                item.isNotFilled = true;
              }
            }
          });

          if (requiredFieldNotFilled) {
            FlashService.Error('Please, fill all required Data Collection fields');
            return;
          }

          self.activityData.dataCollection = self.activityData.dataCollectionItems.filter(function (item) {
            return item.name;
          }).map(function (item) {
            return {
              id: item.id,
              value: item.value
            };
          });
        }

        var loading = FlashService.Loading();

        var data = {
          activityNotes: self.activityData.notes,
          activityActualDuration: self.activityData.actualDuration,
          activityStatusId: self.activityData.progressStatusId,
          dataCollection: self.activityData.dataCollection,
          activityQuantity: self.activityData.quantity,
          activityInformation: { scheduleId: self.activityData.scheduleId }
        };

        TodaysAssignmentsService.SaveActivity(data).then(function (result) {
          loading.dismiss();
          activityCopy = angular.copy(self.activityData);
          FlashService.Success(result.data.message);

          if (self.activityData.facilityCode && self.activityData.roomNumber) {
            TALocationService.GoToTheRoomGroups(self.activityData.facilityCode, self.activityData.roomNumber);
          } else {
            TALocationService.GoToTheHomePage();
          }
        });
      };

      self.CancelActivity = function () {
        self.activityData = angular.copy(activityCopy);
      };

      self.UpdateRoomNote = function (roomNote, dbAction) {
        var data = {};
        data.facilityCode = roomNote.facilityCode;
        data.facilityName = roomNote.facilityName;
        data.roomNumber = roomNote.roomNumber;
        data.date = moment().add(1, 'days');
        data.note = roomNote.note;
        data.action = dbAction;

        var loading = FlashService.Loading();
        TodaysAssignmentsService.UpdateRoomNote(data).then(function (result) {
          loading.dismiss();

          if (result.success) {
            FlashService.Success(result.data.message);

            data.isEditMode = false;
            updateRoomNoteInActivitiesList(data, dbAction);

            switch (dbAction) {
              case self.DBActions.Insert:
                self.roomNotesForTomorrow.unshift(data);

                break;

              case self.DBActions.Delete:
                self.roomNotesForTomorrow = self.roomNotesForTomorrow.filter(function (roomNote) {
                  return roomNote.facilityCode !== data.facilityCode && roomNote.roomNumber !== data.roomNumber;
                });

                self.roomNotesDropdown.unshift({ facilityCode: data.facilityCode, facilityName: data.facilityName, roomNumber: data.roomNumber });

                break;
            }
          }
        });
      };

      self.AreActionsForbidden = function () {
        return self.roomInfo && !self.roomInfo.roomIsStarted || !self.isCurrentDaySelected();
      };

      self.IsActivityDataDisabled = function (activity) {
        return !isOtherActivity(activity) && self.activityAdditionalInfo && !self.activityAdditionalInfo.roomIsStarted;
      };

      self.scrollToActivity = function (scheduleId) {

        $timeout(function () {
          var scrollToTarget = $('#activity-' + scheduleId).offset().top;

          if (scrollToTarget) {
            $(".scrollable-area").animate({ scrollTop: scrollToTarget - 100 + "px" }, "slow");
          }

        }, 1000);
      };

      function composeActivitiesGroup(activitiesGroup) {
        activitiesGroup = sortRackGroupActivities(activitiesGroup);

        activitiesGroup.forEach(function (activity) {
          if (isSpecificTime(activity.time)) {
            activity.isOverdued = isActivityOverdued(activity);

            activity.elementClassName = ElementIdHelper.getActivityElementClassName(activity.scheduleId, activity.progressStatusId);

            if (activity.dataCollectionItems) {
              var itemsPerRow = 2;

              activity.dataCollectionRowsCount = Math.floor(activity.dataCollectionItems.length / itemsPerRow);
            }
          }

          if (activity.leeway && moment(activity.lastDayInLeeway).isValid()) {
            activity.lastDayInLeewayToDisplay = moment(activity.lastDayInLeeway).format('MMM D');
          }
        });

        return activitiesGroup;
      }

      function isSpecificTime(activityTime) {
        return activityTime && activityTime.length > 0 && activityTime !== 'AM' && activityTime !== 'PM';
      }

      function isActivityOverdued(activity) {
        var currentTime = moment(moment().format('h:mm a'), 'h:mm a');
        var activityTime = moment(activity.time, 'h:mm a');

        return activityTime.isBefore(currentTime);
      }

      function isOtherActivity(activity) {
        return !activity.facilityCode || !activity.roomNumber;
      }

      function spreadRoomNotesIntoPrepList(prepListRoomActivitiesGroups, roomNotes) {
        roomNotes.forEach(function (roomNote) {
          prepListRoomActivitiesGroups.forEach(function (facilityCodeGroup) {
            facilityCodeGroup.roomNumberGroups.forEach(function (roomItemGroup) {
              if (roomNote.facilityCode === roomItemGroup.items[0].facilityCode && roomNote.roomNumber === roomItemGroup.items[0].roomNumber && ((moment(roomNote.date)).startOf('day')).isSame((moment(roomItemGroup.items[0].scheduleDate)).startOf('day'))) {
                roomItemGroup.roomNote = roomNote;
              }
            });
          });
        });
      }

      function updateRoomNoteInActivitiesList(roomNote, dbAction) {
        self.spreadedGroupsForTomorrow.facilityRoomActivitiesGroups.forEach(function (facilityCodeGroup) {
          facilityCodeGroup.roomNumberGroups.forEach(function (roomItemGroup) {
            if (roomNote.facilityCode === roomItemGroup.items[0].facilityCode && roomNote.roomNumber === roomItemGroup.items[0].roomNumber && ((moment(roomNote.date)).startOf('day')).isSame((moment(roomItemGroup.items[0].scheduleDate)).startOf('day'))) {
              if (dbAction === self.DBActions.Delete) {
                roomItemGroup.roomNote = null;
              } else {
                roomItemGroup.roomNote = roomNote;
              }
            }
          });
        });
      }

      function getItemsForRoomNotesDropdown(prepListRoomActivitiesGroups, roomNotes) {
        var roomNotesDropdown = [];

        prepListRoomActivitiesGroups.forEach(function (facilityCodeGroup) {
          facilityCodeGroup.roomNumberGroups.forEach(function (roomItemGroup) {
            var existingRoomNote = roomNotes.filter(function (roomNote) { return roomNote.facilityCode === roomItemGroup.items[0].facilityCode && roomNote.roomNumber === roomItemGroup.items[0].roomNumber && moment(roomNote.date).isSame(moment(roomItemGroup.items[0].scheduleDate)); })[0];

            if (!existingRoomNote) {
              roomNotesDropdown.push({ facilityCode: facilityCodeGroup.key, facilityName: facilityCodeGroup.items[0].facilityName, roomNumber: roomItemGroup.key });
            }
          });
        });

        return roomNotesDropdown;
      }

      function spreadPreparationActivitiesIntoGroups(activities) {
        var spreadedGroups = {
          facilityRoomActivitiesGroups: [],
          staffActivitiesGroup: [],
          facilityActivitiesGroups: [],
          areaActivitiesGroups: [],
        };

        var facilityRoomActivitiesList = activities.filter(function (activity) {
          return activity.activityTypeId === self.activityType.Room || activity.activityTypeId === self.activityType.Rack ||
            activity.activityTypeId === self.activityType.Cage || activity.activityTypeId === self.activityType.Equipment || activity.activityTypeId === self.activityType.Preparation || activity.activityTypeId === self.activityType.QCCheck;
        });
        spreadedGroups.facilityRoomActivitiesGroups = facilityRoomActivitiesList.groupBy('facilityCode');
        spreadedGroups.facilityRoomActivitiesGroups.forEach(function (facilityCodeGroup) {
          facilityCodeGroup.roomNumberGroups = facilityCodeGroup.items.groupBy('roomNumber');
        });

        var staffActivitiesList = activities.filter(function (activity) {
          return activity.activityTypeId === self.activityType.Staff;
        });
        spreadedGroups.staffActivitiesGroup = staffActivitiesList;

        var facilityActivitiesList = activities.filter(function (activity) {
          return activity.activityTypeId === self.activityType.FacilityArea && activity.facilityCode;
        });
        spreadedGroups.facilityActivitiesGroups = facilityActivitiesList.groupBy('facilityCode');

        var areaActivitiesList = activities.filter(function (activity) {
          return activity.activityTypeId === self.activityType.FacilityArea && activity.areaName;
        });
        spreadedGroups.areaActivitiesGroups = areaActivitiesList.groupBy('areaName');

        return spreadedGroups;
      }

      function createAdHocCountsActivitiesGroup(rackGroup) {

        rackGroup.adHocCountActivities = rackGroup.activities.filter(function (activity) {
          return activity.quantityTypeId && activity.quantityTypeId === self.QuantityTypes.PercentageOfCageCount;
        }).sort(function (activity1, activity2) { //order activities by Activity Name in Ad Hoc Counts group

          var activity1Name = activity1.name.toUpperCase();
          var activity2Name = activity2.name.toUpperCase();

          if (activity1Name < activity2Name) {
            return -1;
          }
          if (activity1Name > activity2Name) {
            return 1;
          }
          return 0;
        });

        if (self.actualHoursSystemPreference) {
          rackGroup.adHocCountActivities.forEach(function (activity) {
            var actPercentageDcField = {
              name: "Actual percentage",
              value: activity.quantity,
              required: true,
              isAdHocCountActDc: true
            };

            if (activity.dataCollectionItems == null || activity.dataCollectionItems.length == 0) {
              activity.dataCollectionItems = [actPercentageDcField];
            }
            else {
              activity.dataCollectionItems.unshift(actPercentageDcField);
            }
          });
        }

        rackGroup.activities = rackGroup.activities.filter(function (activity) {
          return activity.quantityTypeId !== self.QuantityTypes.PercentageOfCageCount;
        });
      }

      function sortTimeSpecificActivities(activities) {

        return (activities || []).sort(function (activity1, activity2) {

          var activity1Time = moment(activity1.time, 'h:mm a');
          var activity2Time = moment(activity2.time, 'h:mm a');

          if (activity1Time.isBefore(activity2Time)) {
            return -1;
          }
          if (activity1Time.isAfter(activity2Time)) {
            return 1;
          }

          if (activity1.rackId && activity2.rackId) {

            if (activity1.rackId.toLowerCase() < activity2.rackId.toLowerCase()) {
              return -1;
            }
            if (activity1.rackId.toLowerCase() > activity2.rackId.toLowerCase()) {
              return 1;
            }
          }

          return 0;

        });
      }

      function sortRackGroupActivities(activities) {

        return (activities || []).sort(function (activity1, activity2) {

          if (parseInt(activity1.sequence) < parseInt(activity1.sequence)) {
            return -1;
          }
          if (parseInt(activity1.sequence) > parseInt(activity1.sequence)) {
            return 1;
          }

          var activity1Time = moment(activity1.time, 'h:mm a');
          var activity2Time = moment(activity2.time, 'h:mm a');

          if (activity1Time.isBefore(activity2Time)) {
            return -1;
          }
          if (activity1Time.isAfter(activity2Time)) {
            return 1;
          }

          return 0;

        });
      }

      function loadTimeSpecificActivities(isDataChangedBySocket) {

        var deferred = $q.defer();

        self.timeSpecificActivitiesLoading = isDataChangedBySocket;
        TodaysAssignmentsService.GetTimeSpecificActivities(moment()).then(function (result) {

          self.timeSpecificActivities = composeActivitiesGroup(result.data.timeSpecificActivities);
          self.timeSpecificActivities = sortTimeSpecificActivities(self.timeSpecificActivities);

          if (isDataChangedBySocket) {
            var records = self.timeSpecificActivities.filter(function (activity) { return socketData.scheduleIds.indexOf(activity.scheduleId) > -1; });
            self.timeSpecificActivitiesChanged = records.length > 0;
            if (self.timeSpecificActivitiesChanged) {
              $timeout(function () {
                self.timeSpecificActivitiesChanged = false;
              }, 30000);
            }
          }

          deferred.resolve();
        });

        return deferred.promise;
      }

      function updateActivity(activity, newActivityProgressStatusName) {
        activity.progressStatusName = newActivityProgressStatusName;
        activity.progressStatusId = self.progressStatuses.getProgressStatusIdByStatusName(newActivityProgressStatusName);
        activity.elementClassName = ElementIdHelper.getActivityElementClassName(activity.scheduleId, activity.progressStatusId);

        activity.isActivityProgressStatusIconChanging = true;

        $timeout(function () {
          activity.progressStatusIcon = self.progressStatuses.getProgressStatusIconByStatusName(activity.progressStatusName);
          activity.isActivityProgressStatusIconChanging = false;
        }, 100);
      }

      function markAdHocCountsComplete(activities) {
        var data = {
          actualHoursSystemPreference: self.actualHoursSystemPreference,
          date: moment(),
          activityItems: []
        };

        activities.forEach(function (activity) {
          var activityItem = {
            scheduleId: activity.scheduleId,
            actualDuration: activity.actualDuration,
            dataCollectionItems: []
          };

          if (activity.dataCollectionItems && activity.dataCollectionItems.length > 0) {

            activity.dataCollectionItems.forEach(function (item) {
              if (item.isAdHocCountActDc && self.actualHoursSystemPreference) {
                activityItem.scheduleId = activity.scheduleId;
                activityItem.activityQuantity = item.value;

              } else if (item.name && item.value !== undefined) {
                activityItem.dataCollectionItems.push({
                  id: item.id,
                  value: item.value
                });
              }
            });
          }
          data.activityItems.push(activityItem);
        });

        var activitiesCopy = angular.copy(activities);

        activities.forEach(function (activity) {
          self.totalHoursRemaining -= activity.remainingDuration;

          updateActivity(activity, self.progressStatuses.StatusNamesConstants.Completed);
        });

        FlashService.Success(activities.length & activities.length > 1 ? 'Activities have been signed-off' : 'Activity has been signed-off');

        TodaysAssignmentsService.MarkComplete(data).then(function (result) {

          if (!result.success) {
            activities.forEach(function (activity) {
              var activityCopy = activitiesCopy.firstOrDefault(function (actCopy) {
                return parseInt(actCopy.scheduleId) === parseInt(activity.scheduleId);
              });

              if (activityCopy) {
                self.totalHoursRemaining -= activity.remainingDuration;

                updateActivity(activity, activityCopy.progressStatusName);
              }
            });
          }

          loadTimeSpecificActivities().then(function () {

          });
        });
      }

      function markActivitiesComplete(activities) {
        var data = {
          actualHoursSystemPreference: self.actualHoursSystemPreference,
          date: moment(),
          activityItems: []
        };

        activities.forEach(function (activity) {
          var activityItem = {
            scheduleId: activity.scheduleId,
            actualDuration: activity.actualDuration,
            dataCollectionItems: []
          };

          if (activity.dataCollectionItems && activity.dataCollectionItems.length > 0) {

            activity.dataCollectionItems.forEach(function (item) {
              if (item.name && item.value !== undefined) {
                activityItem.dataCollectionItems.push({
                  id: item.id,
                  value: item.value
                });
              }
            });
          }

          data.activityItems.push(activityItem);
        });

        var activitiesCopy = angular.copy(activities);

        activities.forEach(function (activity) {
          self.totalHoursRemaining -= activity.remainingDuration;

          updateActivity(activity, self.progressStatuses.StatusNamesConstants.Completed);
        });

        FlashService.Success(activities.length & activities.length > 1 ? 'Activities have been signed-off' : 'Activity has been signed-off');

        TodaysAssignmentsService.MarkComplete(data).then(function (result) {

          if (!result.success) {
            activities.forEach(function (activity) {
              var activityCopy = activitiesCopy.firstOrDefault(function (actCopy) {
                return parseInt(actCopy.scheduleId) === parseInt(activity.scheduleId);
              });

              if (activityCopy) {
                self.totalHoursRemaining -= activity.remainingDuration;

                updateActivity(activity, activityCopy.progressStatusName);
              }
            });
          }

          loadTimeSpecificActivities().then(function () {

          });
        });
      }

      function markCompleteTimeSpecificActivity(activity, needStartInRoom) {

        if (activity.dataCollectionItems && activity.dataCollectionItems.some(function (item) { return item.name && item.required && item.value === undefined; })) {
          var dataCollectionPopup = Utils.OpenModal('', 'ng1/src/todaysAssignments/popups/dataCollectionDialog.html', 'dataCollectionDialogCtrl', activity, null, null, true);
          dataCollectionPopup.result.then(function (processedActivity) {
            dataCollectionPopup.dismiss();

            if (processedActivity) {
              finishTimeSpecificActivityComplete(processedActivity, needStartInRoom);
            }
          });
        } else {
          finishTimeSpecificActivityComplete(activity, needStartInRoom);
        }
      }

      function finishTimeSpecificActivityComplete(activity, needStartInRoom) {

        var data = {
          actualHoursSystemPreference: self.actualHoursSystemPreference,
          actualDuration: activity.actualDuration,
          scheduleId: activity.scheduleId,
          date: moment(),
          needStartInRoom: needStartInRoom,
          facilityCode: activity.facilityCode,
          roomNumber: activity.roomNumber,
          dataCollection: []
        };

        if (activity.dataCollectionItems && activity.dataCollectionItems.length > 0) {

          activity.dataCollectionItems.forEach(function (item) {

            if (item.name && item.value !== undefined) {
              data.dataCollection.push({
                id: item.id,
                value: item.value
              });
            }
          });
        }

        var activityCopy = angular.copy(activity);

        activity.progressStatusName = self.progressStatuses.StatusNamesConstants.Completed;
        self.totalHoursRemaining -= activity.remainingDuration;

        FlashService.Success('Activity has been signed-off');

        TodaysAssignmentsService.CompleteTimeSpecificActivity(data).then(function (result) {
          if (!result.success) {
            activity.progressStatusName = activityCopy.progressStatusName;
            self.totalHoursRemaining += activity.remainingDuration;
          }
        });
      }

      function needRefresh(callback) {

        if (!moment().isSame(callback.date, 'day')) {
          return false;
        }

        if (callback.draggedAssigneeId === currentUser.userId) {
          return true;
        }

        var contain = false;

        if (level === Constants.TodaysAssignments.Levels.HomePage) {

          contain = self.roomActivities.filter(a =>
            a.roomNumber === callback.dailySocketFacilities[0].roomNumber &&
            a.facilityCode === callback.dailySocketFacilities[0].facilityCode
          ).length > 0;

          if (contain) {
            return contain;
          }

          contain = self.otherActivities.filter(a =>
            a.AreaId && a.AreaId === callback.dailySocketFacilities[0].AreaId ||
            a.facilityCode && a.facilityCode === callback.dailySocketFacilities[0].facilityCode
          ).length > 0;

          if (contain) {
            return contain;
          }

          contain = (self.preparationActivitiesForToday || []).filter(a =>
            a.roomNumber === callback.dailySocketFacilities[0].roomNumber &&
            a.facilityCode === callback.dailySocketFacilities[0].facilityCode
          ).length > 0;

          if (contain) {
            return contain;
          }

          contain = (self.qcCheckActivitiesByRooms || []).filter(a =>
            a.roomNumber === callback.dailySocketFacilities[0].roomNumber &&
            a.facilityCode === callback.dailySocketFacilities[0].facilityCode
          ).length > 0;

          if (contain) {
            return contain;
          }

          contain = (self.preparationActivitiesForTomorrow || []).filter(a =>
            a.roomNumber === callback.dailySocketFacilities[0].roomNumber &&
            a.facilityCode === callback.dailySocketFacilities[0].facilityCode
          ).length > 0;

          if (contain) {
            return contain;
          }
        }

        if (level === Constants.TodaysAssignments.Levels.RoomGroups || level === Constants.TodaysAssignments.Levels.RackDetails) {

          contain = self.roomInfo.roomNumber === callback.dailySocketFacilities[0].roomNumber &&
            self.roomInfo.facilityCode === callback.dailySocketFacilities[0].facilityCode;


          if (contain) {
            return contain;
          }
        }
        
        if (level === Constants.TodaysAssignments.Levels.ActivityDetails) {
          contain = self.activityData.roomNumber === callback.dailySocketFacilities[0].roomNumber &&
            self.activityData.facilityCode === callback.dailySocketFacilities[0].facilityCode;

          //contain = self.roomActivitiesGroup.activities.filter(function (activity) { return callback.scheduleIds.indexOf(activity.scheduleId) > -1; }).length > 0;
          if (contain) {
             return contain;
          }
        }

        if (level === Constants.TodaysAssignments.Levels.PreparationList) {
          contain = (self.preparationActivitiesForToday || []).some(function (a) {
            return a.roomNumber === callback.dailySocketFacilities[0].roomNumber &&
              a.facilityCode === callback.dailySocketFacilities[0].facilityCode;
          });

          if (contain) {
            return contain;
          }

          contain = (self.preparationActivitiesForTomorrow || []).some(function (a) {
            return a.roomNumber === callback.dailySocketFacilities[0].roomNumber &&
              a.facilityCode === callback.dailySocketFacilities[0].facilityCode;
          });

          if (contain) {
            return contain;
          }
        }

        contain = self.timeSpecificActivities && self.timeSpecificActivities.filter(function (activity) {
          return callback.scheduleIds.indexOf(activity.scheduleId) > -1;
        }).length > 0;

        return contain;
      }
    }

    function composeRoomData(data) {
      var page = data;
      page.todayDate = moment().format('LL');
      page.roomInstructions = $sce.trustAsHtml(page.roomInstructions);
      return page;
    }

    function composeActivityData(data) {
      var page = data;

      page.todayDate = moment().format('LL');
      page.activityStatus = { id: data.activityStatusId, value: data.activityStatusName };

      return page;
    }

    return (TodaysAssignments);
  }]);
